import * as React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import "./App.scss";
import ProductDetails from "../views/ProductDetails/component";
import EmptyPage from "../views/EmptyPage/component";
import PrivacyPolicy from "../views/PrivacyPolicy/component";
import HomePageNew from "../views/HomePageNew/component";
import Login from "../views/Login/component";
import ManageAddress from "../views/ManageAddress/component";
import PreRazorpay from "../views/Razorpay/PreRazorpay";
import SellerPage from "../views/SellerPage/component";
import Checkout from "../views/Checkout/component";
import OrderDetails from "../views/OrderDetails/component";
import ScrollToTop from "../components/common/ScrollToTop.js";
import CategorySection from "../views/CategorySection/component.js";
import MobileSearchResult from "../views/MobileSearchResults/component.js";
import QuickCommerce from "../views/QuickCommerce/component.js";
import SharePage from "../views/SharereferralCodePage/component.js";
import TermsAndCondition from "../components/common/terms/termsAndConditions.js";
import RefundAndCancellationPolicy from "../components/common/terms/refundAndCancellationPolicy.js";
import ReturnPolicy from "../components/common/terms/returnPolicy.js";
import ShippingAndDelivery from "../components/common/terms/shippingAndDelivery.js";
import TopGroceryStores from "../views/TopGroceryStores/component"
import { useDispatch } from 'react-redux';
import { addToHistory } from "../slices/userSlice";
import ThankYou from "../views/ThankYou/component";
import LogRocket from 'logrocket';

const PrivateRoute = ({ element: Element, ...rest }) => {
  const isAuthenticated = JSON.parse(localStorage.getItem("token"));
  return isAuthenticated ? <Element /> : <Navigate to="/" replace />;
};


const RoutePath = () => {
  const location = useLocation();
  const lowerCasePath = location.pathname.toLowerCase();
  if (location.pathname !== lowerCasePath) {
    return <Navigate to={lowerCasePath} replace />;
  }
  return null;
};


function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (process.env.REACT_APP_NODE_ENV === "production") {
      LogRocket.init('s23vfk/kiko');
    }
  }, []);
  React.useEffect(() => {
    dispatch(addToHistory(location.pathname));
  }, [location, dispatch]);
  return (
    <>
      <ScrollToTop />
      <RoutePath />
      <Routes>
        <Route path="/seller" element={<SellerPage />} />
        <Route path="/" element={<HomePageNew />} />
        <Route path="/empty-page" element={<EmptyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/top-grocery-stores" element={<TopGroceryStores />} />
        <Route path="/product-details" element={<ProductDetails />} />
        <Route path="/manageAddress" element={<ManageAddress />} />
        <Route path="/login" element={<Login />} />
        <Route path="/preRazorpay" element={<PreRazorpay />} />
        <Route path="/buyer-checkout" element={<PrivateRoute element={Checkout} />} />
        <Route path="/buyer-order-details" element={<PrivateRoute element={OrderDetails} />} />
        <Route path="/category" element={<CategorySection />} />
        <Route path="/mobile-search-result" element={<MobileSearchResult />} />
        <Route path="/quickcommerce" element={<QuickCommerce />} />
        <Route path="/qc" element={<QuickCommerce />} />
        <Route path="/terms-and-condition" element={<TermsAndCondition />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/shipping-and-delivery-policy" element={<ShippingAndDelivery />} />
        <Route path="/refund-and-cancellation-policy" element={<RefundAndCancellationPolicy />} />
        <Route path="/share-referral-code/:id" element={<SharePage />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </>
  );
}

export default App;
